import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import "./index.css";
import { queryClient } from "./lib/queryClient";
import { initPWAInstallListener } from "./hooks/usePWAInstall";
import { ensureDeviceId } from "./utils/deviceId";

// React 마운트 전에 PWA 설치 이벤트 캡처
initPWAInstallListener();

// 기기 ID를 IndexedDB ↔ localStorage 간 조기 복구 (한쪽이 지워져도 동일 ID 유지)
void ensureDeviceId();

// index.html 의 PWA self-heal 가드가 설정한 플래그 해제 (정상 부팅 = 복구 성공)
try {
  sessionStorage.removeItem("__hc_sw_recovered__");
} catch {
  /* sessionStorage 접근 불가 환경은 무시 */
}

// 배포 후 새 서비스워커가 활성화(skipWaiting+clients.claim)되면 화면을 한 번 자동으로 다시 불러온다.
// 프리캐시된 옛 index.html 이 첫 새로고침 때 그대로 내려와 새 라우트/청크가 없는 옛 번들이 남던 문제 방지.
// (이미 SW 가 제어 중인 페이지에서만 동작 → 최초 설치 때는 새로고침하지 않음)
if (typeof navigator !== "undefined" && "serviceWorker" in navigator && navigator.serviceWorker.controller) {
  let refreshing = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
